import script from "./Splitpanes.vue?vue&type=script&lang=js"
export * from "./Splitpanes.vue?vue&type=script&lang=js"

import "./Splitpanes.vue?vue&type=style&index=0&id=66f8feaa&lang=scss"

const __exports__ = script;

export default __exports__